import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="about">
      <Header />

      <main className="about-content">
        <section className="hero-section">
          <div className="breadcrumb">
            <Link to="/" onClick={toTop}>
              Home
            </Link>
            <span className="separator">&rsaquo;</span>
            <span className="current">About Us</span>
          </div>

          <div className="hero-text">
            <h1>
              Enrichment for <span className="highlight">Pets</span> &{" "}
              <span className="highlight">People</span>
            </h1>
            <p>
              We're Pawluna. We bridge the gap between ideas and shelves,
              ensuring better pet products reach the world faster and with less
              risk.
            </p>
          </div>
        </section>

        <section className="features-section">
          <div className="section-header">
            <h2>Our Own Fun & Enrichment Products</h2>
            <p>
              Our own brand is where our ideas meet pets' daily lives. We design
              and make fun, interactive enrichment products that turn mealtime
              and play into positive, engaging experiences.
            </p>
          </div>

          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="icon-wrapper digestion-icon">
                <img src="/main/a1-1.svg" alt="Healthy Digestion" />
              </div>
              <h3>Healthy Digestion</h3>
              <p>
                Our slow feeders prevent bloating and indigestion by turning a
                30-second gulp into a 15-minute engaging meal.
              </p>
            </div>

            <div className="benefit-item">
              <div className="icon-wrapper anxiety-icon">
                <img src="/main/a1-2.svg" alt="Anxiety Relief" />
              </div>
              <h3>Anxiety Relief</h3>
              <p>
                Repetitive licking is self-soothing. Our lick mats release
                endorphins to help calm pets during storms or grooming.
              </p>
            </div>

            <div className="benefit-item">
              <div className="icon-wrapper mental-icon">
                <img src="/main/a1-3.svg" alt="Mental Stimulation" />
              </div>
              <h3>Mental Stimulation</h3>
              <p>
                Boredom leads to destructive behavior. Our puzzles challenge
                your pet's mind, tiring them out faster than a walk.
              </p>
            </div>
          </div>

          <div className="product-cards-grid">
            <div className="product-card">
              <div className="card-image">
                <img src="/img/102.jpg" alt="Food Enrichment" />
              </div>
              <div className="card-body">
                <h3>Food Enrichment</h3>
                <p>
                  Pawluna slow-feeding bowls and lick mats that turn everyday meals
                  into calmer, healthier routines.
                </p>
                <Link to="/shop" onClick={toTop} className="learn-more">
                  LEARN MORE &gt;
                </Link>
              </div>
            </div>

            <div className="product-card">
              <div className="card-image">
                <img src="/img/1016.jpg" alt="Sensory Enrichment" />
              </div>
              <div className="card-body">
                <h3>Sensory Enrichment</h3>
                <p>
                  Textured rubber geometric toys that stimulate chewing, playing
                  and exploring through distinctive shapes and feel.
                </p>
                <Link to="/shop" onClick={toTop} className="learn-more">
                  LEARN MORE &gt;
                </Link>
              </div>
            </div>

            <div className="product-card">
              <div className="card-image">
                <img src="/img/1011.jpg" alt="Mental Enrichment" />
              </div>
              <div className="card-body">
                <h3>Mental Enrichment</h3>
                <p>
                  LunaPath enrichment bowls that encourage pets to think,
                  nudge and spin for their food.
                </p>
                <Link to="/shop" onClick={toTop} className="learn-more">
                  LEARN MORE &gt;
                </Link>
              </div>
            </div>

            <div className="product-card">
              <div className="card-image">
                <img src="/img/1010.jpg" alt="Cognitive Enrichment" />
              </div>
              <div className="card-body">
                <h3>Cognitive Enrichment</h3>
                <p>
                  Layered puzzle designs with varied pathways that support
                  progressive enrichment challenges for dogs.
                </p>
                <Link to="/shop" onClick={toTop} className="learn-more">
                  LEARN MORE &gt;
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
